import { render, staticRenderFns } from "./ReviewsHeader.vue?vue&type=template&id=285c3ccb&scoped=true&"
import script from "./ReviewsHeader.vue?vue&type=script&lang=ts&"
export * from "./ReviewsHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewsHeader.vue?vue&type=style&index=0&id=285c3ccb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285c3ccb",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon,QSpace,QBtn});
